/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/dashboard/dialogs/add-widget/dashboard.dialogs.add-widget.component.ts.
 */
import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DashboardWidgetService} from '../../services/dashboard.widget.service';
import {DashboardWidgetInterface} from '../../interfaces/dashboard.widget.interface';


/**
 * Zweck: Beschreibt class DashboardDialogsAddWidgetComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    templateUrl: 'dashboard.dialogs.add-widget.component.html',
    styleUrls: ['dashboard.dialogs.add-widget.component.scss'],
    standalone: false
})
export class DashboardDialogsAddWidgetComponent implements OnInit, OnDestroy {
  widgets: DashboardWidgetInterface[];

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public dialogRef: MatDialogRef<DashboardDialogsAddWidgetComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any[], private svc: DashboardWidgetService) {
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {

  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.widgets = this.data;
  }

/**
 * Beschreibt Methode send und ihren Rückgabevertrag.
 */
  send(widget) {
    this.dialogRef.close(widget);
  }

/**
 * Beschreibt Methode cancel und ihren Rückgabevertrag.
 */
  cancel() {
    this.dialogRef.close(false);
  }
}
